<template>
    <div class="row" v-if="rank">
        <div class="col-12 text-center py-1" v-if="rank.gap">...</div>
        <div class="col-1 text-nowrap">
            {{ rank.rank > 0 ? rank.rank + '.' : '' }}
        </div>
        <div class="col-9 text-nowrap text-truncate">
            <sakali-user
                    :user="rank.user"
                    :show-team="showTeam"
                    :show-user="showUser"
                    :highlight="loggedIn && (rank.user.id === user.id)"/>
        </div>
        <div class="col-2 text-nowrap"
             :class="{'text-sakali-live': live}">
            {{ rank.points | float }}
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    props: {
        rank: Object,
        live: Boolean,
        showTeam: {
            type: Boolean,
            default: false
        },
        showUser: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters(['loggedIn', 'user'])
    }
}
</script>
